import { connect, useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import { Draggable } from "react-drag-reorder";
import {
  updateTechnologyResourcePriority,
  getTechnologyResources,
} from "../../../../action/masters/technologyResourceActionCreator";
import {
  changePositionOnDrag,
  prioratiseItems,
  sortAlphabetically,
} from "../../../../common-functions/commonFunctions";
import { cloneDeep, baseURL } from "../../../../constants/commonConstants";
import { getAlertData } from "../../../../helper/sweet-alert";
import {
  IUpdateTechnologyResourcePriority,
  ITechnologyResourceData,
} from "../../../../models/master/technologyResource";
import { setTechnologyResources } from "../../../../store/slices/master/technologyResourceSlice";
import LoaderSpinner from "../../../../common-components/loader";
import FloatingLabelDropDown from "../../../../common-components/floatingdropdown";
import { UserRole } from "../../../../constants/RoleEnum";
import {
  getColleges,
  getDepartments,
} from "../../../../action/common/commonActionCreator";
import {
  setColleges,
  setDepartments,
} from "../../../../store/slices/common/commonSlice";

const PriorityTechnologyResource = (
  props: IUpdateTechnologyResourcePriority
) => {
  const {
    updateTechnologyResourcePriority,
    getTechnologyResources,
    technologyResources,
    configUserRole,
    currentRole,
    currentCollege,
    currentDepartment,
    getColleges,
    colleges,
    getDepartments,
    departments,
  } = props;
  const [filteredItems, setfilteredItems] = useState<any[]>([]);
  const [loader, setLoader] = useState(true);
  const [alertType, setAlertType] = useState<any>("success");
  const [alertTitle, setAlertTitle] = useState<string>("Default");
  const [selectedCollege, setSelectedCollege] = useState<any>(null);
  const [selectedDepartment, setSelectedDepartment] = useState<any>(null);
  const dispatch = useDispatch();

  const saveChangedPos = async (currentPos: any, newPos: any) => {
    if (currentPos != newPos) {
      setLoader(true);
      let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
      await setfilteredItems(_items);
      updateTechnologyResourcePriority(_items, setAlert);
    }
  };

  const ChangeVisibleOrNot = async (id: number, _displayOrNot: boolean) => {
    /////method 1
    setLoader(true);

    let index = filteredItems.findIndex((x) => x.id == id);
    let _afterFilteration = [];
    let _filteredItems = [...filteredItems];
    let selectedItem = _filteredItems.splice(index, 1);
    selectedItem[0].displayOrNot = _displayOrNot;

    selectedItem[0].priority = null;
    _afterFilteration = [
      ...prioratiseItems(_filteredItems.filter((x) => x.displayOrNot == true)),
      ...selectedItem,
      ..._filteredItems.filter((x) => x.displayOrNot == false),
    ];
    let _items = prioratiseItems(_afterFilteration);

    setfilteredItems([..._items]);
    updateTechnologyResourcePriority(_items, setAlert);
    //let _items = changePositionOnDrag(filteredItems, currentPos, newPos);
    // await setfilteredItems(_items);
    // //const itemsForSave = _items.slice(newPos);
    // updateAppPriority(_items, setAlert);

    /////method 2
    // let _filteredItems = [...filteredItems]
    // let item = _filteredItems[index];
    // item.displayOrNot = __displayOrNot;
    // _filteredItems[index] = item;
    // updateAppPriority(item, setAlert);
    // setFilteredItems(_filteredItems);
  };

  const setAlert = (type: string) => {
    let alertData = getAlertData(type);
    if (alertData) {
      setLoader(false);
      setAlertType(alertData.type);
      setAlertTitle(alertData.title);
    }
  };

  const getAlltechnologyResources = async (
    configUserRoleId: number,
    collegeId?: number,
    departmentId?: number
  ) => {
    setLoader(true);
    try {
      await getTechnologyResources(configUserRoleId, collegeId, departmentId);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getColleges && getColleges();
    return () => {
      dispatch(setTechnologyResources([]));
      dispatch(setColleges([]));
      dispatch(setDepartments([]));
    };
  }, [configUserRole]);

  useEffect(() => {
    technologyResources && setfilteredItems(cloneDeep(technologyResources));
  }, [technologyResources]);

  useEffect(() => {
    if (
      colleges &&
      colleges?.length > 0 &&
      currentRole == UserRole.SuperAdmin
    ) {
      const defaultCollegeId = colleges[0]?.id;
      setSelectedCollege(defaultCollegeId);
      getDepartments && getDepartments(defaultCollegeId);
    } else {
      setSelectedCollege(currentCollege);
      setSelectedDepartment(currentDepartment);
    }
  }, [colleges, currentRole]);

  useEffect(() => {
    if (
      departments &&
      departments.length > 0 &&
      currentRole === UserRole.SuperAdmin
    ) {
      setSelectedDepartment(departments[0].id);
    }
  }, [departments, selectedCollege]);

  useEffect(() => {
    if (selectedCollege && selectedDepartment) {
      getAlltechnologyResources(
        configUserRole,
        selectedCollege,
        selectedDepartment
      );
    }
  }, [selectedCollege, selectedDepartment]);

  const onSelectionChange = useCallback((e: any) => {
    if (e.target.name === "college") {
      setSelectedCollege(e.target.value);
      getDepartments && getDepartments(e.target.value);
    } else if (e.target.name === "department") {
      setSelectedDepartment(e.target.value);
    }
  }, []);

  return (
    <>
      <div className="admincontent">
        <div className="title">
          <h2>Technology Resources</h2>
          <div className="side-filter d-flex justify-content-end w-50">
            {currentRole == UserRole.SuperAdmin && (
              <>
                <div className="col-md-6">
                  <FloatingLabelDropDown
                    label="University Management"
                    placeholder=""
                    onChange={(e: any) => onSelectionChange(e)}
                    isMandatory={false}
                    value={selectedCollege}
                    name="college"
                    optionsList={sortAlphabetically(colleges)}
                    showClear={false}
                  />
                </div>
                <div className="col-md-6">
                  <FloatingLabelDropDown
                    label="Department"
                    placeholder=""
                    onChange={(e: any) => onSelectionChange(e)}
                    isMandatory={false}
                    value={selectedDepartment}
                    name="department"
                    optionsList={sortAlphabetically(departments)}
                    showClear={false}
                  />
                </div>
              </>
            )}
          </div>
        </div>

        <ul className="d-flex gap-3 flex-wrap mt-28">
          {loader ? (
            <LoaderSpinner />
          ) : filteredItems && filteredItems?.length > 0 ? (
            <>
              <Draggable
                onPosChange={async (currentPos, newPos) => {
                  await saveChangedPos(currentPos, newPos);
                }}
              >
                {filteredItems
                  .filter((item: ITechnologyResourceData) => item.displayOrNot)
                  .map(
                    (
                      technologyResource: ITechnologyResourceData,
                      index: number
                    ) => (
                      <li className="admin-card">
                        <div className="top">
                          <span className="handle">
                            <img src="/assets/images/drag.svg" />
                          </span>
                          <span className="counter">
                            {technologyResource.priority}
                          </span>
                          <div className="form-checkbox">
                            <input
                              type="checkbox"
                              checked={technologyResource.displayOrNot}
                              id={
                                technologyResource.priority +
                                "technologyResource"
                              }
                              onChange={() => {
                                ChangeVisibleOrNot(
                                  technologyResource.id ?? 0,
                                  !technologyResource.displayOrNot
                                );
                              }}
                            />
                            <label
                              htmlFor={
                                technologyResource.priority +
                                "technologyResource"
                              }
                            ></label>
                          </div>
                        </div>
                        <div className="btm">
                          <div className="img">
                            <img
                              src={
                                technologyResource.image
                                  ? baseURL + technologyResource.image
                                  : ""
                              }
                              alt=""
                            />
                          </div>
                          <h2>{technologyResource.resourceName}</h2>
                        </div>
                      </li>
                    )
                  )}
              </Draggable>
              {filteredItems
                .filter((item: ITechnologyResourceData) => !item.displayOrNot)
                .map(
                  (
                    technologyResource: ITechnologyResourceData,
                    index: number
                  ) => (
                    <li className="admin-card">
                      <div className="top">
                        <span className="handle">
                          <img src="/assets/images/drag.svg" />
                        </span>
                        <span className="counter">{}</span>
                        <div className="form-checkbox">
                          <input
                            type="checkbox"
                            checked={technologyResource.displayOrNot}
                            id={technologyResource.priority + ""}
                            onChange={() => {
                              ChangeVisibleOrNot(
                                technologyResource.id ?? 0,
                                !technologyResource.displayOrNot
                              );
                            }}
                          />
                          <label
                            htmlFor={technologyResource.priority + ""}
                          ></label>
                        </div>
                      </div>
                      <div className="btm">
                        <div className="img">
                          <img
                            src={
                              technologyResource.image
                                ? baseURL + technologyResource.image
                                : ""
                            }
                            alt=""
                          />
                        </div>
                        <h2>{technologyResource.resourceName}</h2>
                      </div>
                    </li>
                  )
                )}
            </>
          ) : (
            <p>No Records Found</p>
          )}
        </ul>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  updateTechnologyResourcePriority: (data: any, callBack: Function) =>
    updateTechnologyResourcePriority(data, callBack),
  getTechnologyResources: (
    configUserRole: number,
    collegeId?: number,
    departmentId?: number
  ) =>
    getTechnologyResources(configUserRole, undefined, collegeId, departmentId),
  getColleges: () => getColleges(),
  getDepartments: (collegeId?: number) => getDepartments(collegeId),
};

function mapStateToProps(state: any) {
  return {
    technologyResources: state.technologyResource.technologyResources,
    colleges: state.common.colleges,
    departments: state.common.departments,
    currentRole: state.userDetails.userProfileData?.currentRole,
    currentCollege: state.userDetails.userProfileData?.currentCollege?.id,
    currentDepartment: state.userDetails.userProfileData?.currentDepartment?.id,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PriorityTechnologyResource);
